module.exports = __webpack_public_path__ + "media/images/illustrations/StarWorks-Hero_02_Character-a55f60e60abd7de1a38e7e79bafc6007.png";